import { graphql } from "gatsby"
import React from "react"

import PricingTables from "@knowit-alma/common/src/components/organisms/PricingTables/PricingTables"

const PricingTablesBlock = ({ blockDataPricingTables }) => {
  const { links } = blockDataPricingTables || {}
  return <PricingTables table={links} />
}

export const query = graphql`
  fragment PricingTables on WpBlockAcfPricingTables {
    __typename
    blockDataPricingTables {
      links {
        image {
          mediaDetails {
            width
            height
          }
          sourceUrl
          altText
          altTextOriginal
        }
        title
        price
        description
        content
        link {
          target
          title
          url
        }
      }
    }
  }
`

export default PricingTablesBlock
